// extracted by mini-css-extract-plugin
export default {"main":"IngredientForm_main__sv2v+","addBtn":"IngredientForm_addBtn__EJp5m","label":"IngredientForm_label__-kYH6"};